import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";

window.closeTimelineBlockModal = () => {
  updateMeta(true);
  const modal = $('.js-timeline-block-modal.custom')
  modal.removeClass('modal-active');
  $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-content').html("");
  $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-image').html("");
  $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-title').html("");
  $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-bold-title').html("");

  updateTimelineParameter(null);

  $('body').removeClass('overflow-hidden');
  $('html').removeClass('overflow-hidden');
  smoothScrollPlay();
  window.finishTimelineGridAnimation();
};

const updateTimelineParameter = (slug) => {
  const newUrl = new URL(window.location.href);
  if (slug) {
    newUrl.searchParams.set('timeline', slug);
  } else {
    newUrl.searchParams.delete('timeline');
  }
  window.history.replaceState({}, '', newUrl);
}

window.openTimelineBlockModal = (e, slug, meta_title = '', meta_description = '') => {
  const modal = $('.js-timeline-block-modal.custom')
  const information = e.querySelector('.js-timeline-block-content');
  const title = e.querySelector('.js-timeline-block-title');
  const image = e.querySelector('.js-timeline-block-image');
  const bold_title = e.querySelector('.js-timeline-block-bold-title');
  if (information) {
    $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-content').html(information.innerHTML);
  }
  if (title) {
    $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-title').html(title.innerHTML);
  }

  if (image) {
    $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-image').html(generateImageBlockHtml(image.src, title.innerHTML));
  } else {
    $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-image').html('');
  }

  if (bold_title) {
    $('.js-timeline-block-modal .inner-children .js-timeline-block-modal-bold-title').html(bold_title.innerHTML);
  }

  updateTimelineParameter(slug);

  $("#timeline-block-modal-content .inner-children").scrollTop(0);
  updateMeta(false, meta_title, meta_description, false);
  modal.addClass('modal-active');
  $('body').addClass('overflow-hidden');
  $('html').addClass('overflow-hidden');
  initBasicCarousel();
  smoothScrollPause();
  window.startTimelineGridAnimation();
  window.initPopupDivider();
};

window.generateImageBlockHtml = (src, title) => {
  return `<div class="block-wrapper">
        <div class="single-new-block">
            <div class="image">
                <img src="${src}" alt="${title}"/>
            </div>
        </div>
    </div>`;
}
